// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Csv = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" d="M15 4.5H3v9h12z" />
    <path stroke="currentColor" strokeLinejoin="round" d="M3 7.5h12M3 10.5h12M6.5 7.5v6" />
  </svg>
);
const ForwardRef = forwardRef(Csv);
export default ForwardRef;
